interface Highlight {
  icon: string;
  title: string;
  desc: string;
}

const highlights: Highlight[] = [
  {
    icon: "ri-water-flash-line",
    title: "180 m linii brzegowej rzeki Słupi",
    desc: "Prywatny dostęp do wody — kajaki, wędkowanie, relaks nad brzegiem we własnym ogrodzie.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "9 km do Ustki i Słupska",
    desc: "Blisko morza i miasta, a mimo to z dala od zgiełku. Idealne połączenie spokoju i dostępności.",
  },
  {
    icon: "ri-home-smile-2-line",
    title: "Rezydencjalny standard wykończenia",
    desc: "Płytki Versace &amp; IMOLA, parkiet dębowy, stolarka M&amp;S na indywidualne zamówienie.",
  },
  {
    icon: "ri-landscape-line",
    title: "Działka 9 600 m²",
    desc: "W pełni ogrodzona z automatyczną bramą wjazdową, budynkiem gospodarczym i garażem na 2 samochody.",
  },
  {
    icon: "ri-building-2-line",
    title: "\"Rybaczówka\" — osobny budynek",
    desc: "Dwa niezależne mieszkania z potencjałem na wynajem lub zakwaterowanie gości bez ingerencji w część główną.",
  },
];

export default function Highlights() {
  return (
    <section className="bg-stone-50 border-y border-stone-200 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-8 text-center">
          Dlaczego ta nieruchomość
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {highlights.map((h, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-5 border border-gray-100 flex flex-col gap-3 hover:border-amber-200 transition-colors"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-50 border border-amber-100">
                <i className={`${h.icon} text-amber-600 text-xl`} />
              </span>
              <strong className="text-sm font-bold text-gray-900 leading-snug">{h.title}</strong>
              <p
                className="text-xs text-gray-500 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: h.desc }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
